import React, { useState } from "react";
import PropTypes from "prop-types";

import { useMutation } from "react-apollo";

import { Title, Fieldset } from "rbx";
import {
  UPDATE_LOCATION_TYPE_MUTATION,
  DELETE_LOCATION_TYPE_MUTATION
} from "../../graphql/Locations/LocationTypes.graphql";

import LocationTypeForm from "./LocationTypeForm";

import { makeHandleChange, ourToast as toast } from "../../utils";

import { EditFormButtonGroup } from "../inputs";

const INITIAL_STATE = {
  LocationRecIdRef: "",
  LocationTypeRecIdRef: ""
};

const EditLocationTypeForm = ({ id, locType, onComplete }) => {
  const [inputs, setInputs] = useState({ ...INITIAL_STATE, ...locType });
  const [updateLocationType, { loading }] = useMutation(
    UPDATE_LOCATION_TYPE_MUTATION,
    {
      refetchQueries: ["ALL_LOCATION_TYPES_QUERY"]
    }
  );
  const handleChange = makeHandleChange(inputs, setInputs);

  const handleSave = async e => {
    e.preventDefault();
    try {
      const obj = Object.keys(INITIAL_STATE).reduce(
        (acc, curr) =>
          inputs[curr] !== null ? { ...acc, [curr]: inputs[curr] } : acc,
        {}
      );
      await updateLocationType({
        variables: {
          data: {
            ...obj,
            LocationRecIdRef: parseInt(id),
            LocationTypeRecIdRef: parseInt(inputs.LocationTypeRecIdRef)
          },
          where: {
            RecId: parseInt(locType.RecId)
          }
        }
      });
      toast.success("Location Type updated successfully.");
      onComplete();
    } catch (err) {
      toast.error("Error updating Location Type.");
    }
  };
  return (
    <form
      className="edit-location-type-form"
      id="edit-location-type-form"
      onSubmit={handleSave}
    >
      <Title>Edit Location Type</Title>
      <Fieldset disabled={loading}>
        <LocationTypeForm inputs={inputs} onChange={handleChange} />
        <hr />
        <EditFormButtonGroup
          deleteMutation={DELETE_LOCATION_TYPE_MUTATION}
          form="edit-location-type-form"
          refetchQueries={["ALL_LOCATION_TYPES_QUERY"]}
          variables={{ where: { RecId: parseInt(locType.RecId) } }}
          onComplete={onComplete}
        />
      </Fieldset>
    </form>
  );
};

EditLocationTypeForm.propTypes = {
  id: PropTypes.number.isRequired,
  locType: PropTypes.object,
  onComplete: PropTypes.func.isRequired
};

export default EditLocationTypeForm;
